export enum BlocksPortalPage {
  Settings = 'settings',
  PropertyListing = 'properties',
  Dashboard = 'dashboard',
  PropertyDetails = 'property-details',
  Rewards = 'rewards',
  HowItWorks = 'how-it-works',
  SignUp = 'signup',
  PrivacyPolicy = 'privacy-policy',
  PressRelease = 'press-release',
  TermsAndConditions = 'tnc',
  GuestCart = 'guest-cart',
  KeyRisks = 'key-risks',
  OurStory = 'our-story',
  Wallet = 'wallet',
  CookiePolicy = 'cookie-policy',
  PaymentSuccess = 'success',
  FailPayByCard = 'fail-card',
  ConfirmationPayByCard = 'confirmation-card',
  TopUp = 'top-up',
  ContactUs = 'contact',
  ConfirmationPayByDirectDebit = 'direct-debit',
  MyRewards = 'my-rewards',
  MoreInfo = 'more-info',
  PaymentStatus = 'payment-status',
  FaqPages = 'faq-page',
  Teams = 'teams',
  ThirdPartyProviders = 'third-party-providers',
  RiskWarnings = 'risk-warnings',
  BrokerDealerDisclosure = 'broker-dealer-disclosure',
  VirtualAssetStandard = 'virtual-asset-standards',
  PrivacyStatement = 'privacy-statement',
  AntiMoneyLaundering = 'anti-money-laundering',
  AntiBriberyCorruption = 'anti-bribery-corruption',
  ComplaintsHandlingPolicy = 'complaint-handling-policy',
  WhistleBlowingPolicy = 'whistleblowing-policy'
}

export enum BlocksPortalModule {
  Checkout = 'checkout',
  Cart = 'cart',
  Wallet = 'wallet',
  Properties = 'properties',
  Profile = 'profile-log',
  Notifications = 'notifications',
  MyInvestments = 'portfolio',
  StatementHistory = 'statement-history'
}


//////